var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApDryRisersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.873 -8.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.462,29.339a1.233,1.233,0,0,1-1.233,1.235H25.169a1.234,1.234,0,1,1,0-2.451h12.06a1.216,1.216,0,0,1,1.233,1.217Zm-3.65,5.289H25.169a1.234,1.234,0,1,0,0,2.451h9.643a1.234,1.234,0,1,0,0-2.451ZM30,40.975H19.668a5.288,5.288,0,0,1-5.289-5.289V26.958a5.283,5.283,0,0,1,2.909-4.671L20,20.93l-.812,1.357a1.234,1.234,0,0,0,1.093,1.762h12.06a1.234,1.234,0,1,0,0-2.45H22.329l1.516-3.05,0,0a1.219,1.219,0,0,0-.23-1.428A1.235,1.235,0,0,0,22.207,17l-6.03,3a7.755,7.755,0,0,0-4.3,7.053v8.691a7.794,7.794,0,0,0,7.794,7.706H30a1.235,1.235,0,0,0,0-2.47Zm4.691-19.5a1.234,1.234,0,1,0,2.45,0,2.735,2.735,0,0,1,.37-1.481,5.283,5.283,0,0,0,.6-2.539,5.282,5.282,0,0,0-.6-2.539,2.738,2.738,0,0,1-.37-1.446,2.738,2.738,0,0,1,.37-1.481,5.274,5.274,0,0,0,.6-2.539,1.234,1.234,0,0,0-2.468,0,2.907,2.907,0,0,1-.354,1.481,5.282,5.282,0,0,0-.6,2.539,5.272,5.272,0,0,0,.6,2.539,2.915,2.915,0,0,1,.354,1.481,2.907,2.907,0,0,1-.354,1.481,5.3,5.3,0,0,0-.6,2.5Zm8.48-8.005a2.922,2.922,0,0,1,.37-1.481,5.274,5.274,0,0,0,.6-2.539,1.234,1.234,0,1,0-2.451,0,2.9,2.9,0,0,1-.37,1.481,5.281,5.281,0,0,0-.6,2.539,5.272,5.272,0,0,0,.6,2.539,3.153,3.153,0,0,1,0,2.962,5.281,5.281,0,0,0-.6,2.539,1.234,1.234,0,1,0,2.45,0,2.922,2.922,0,0,1,.37-1.481,5.274,5.274,0,0,0,.6-2.539,5.282,5.282,0,0,0-.6-2.539,2.913,2.913,0,0,1-.37-1.481Z",
    transform: "translate(0 0)",
    stroke: "#f0f8ff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApDryRisersIcon);
export default __webpack_public_path__ + "static/media/ap-dry-risers-icon.3f6b705005c9aeda851feceb5f9e71a5.svg";
export { ForwardRef as ReactComponent };